// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"2edf2235","766":"9739b78b"}[chunkId] + ".chunk.css";
};